import { Component } from '@angular/core';

@Component({
    selector: 'app-download-app',
    templateUrl: './download-app.component.html',
    styleUrls: ['./download-app.component.css'],
    standalone: false
})
export class DownloadAppComponent {

}
